import {commitMutation, Disposable, Environment, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../MutationTypes';
import {
	DeleteOutlookCalendarTokensInput,
	DeleteOutlookCalendarTokensMutation,
	DeleteOutlookCalendarTokensMutation$rawResponse,
} from './__generated__/DeleteOutlookCalendarTokensMutation.graphql';

const mutation = graphql`
	mutation DeleteOutlookCalendarTokensMutation($input: DeleteOutlookCalendarTokensInput!) @raw_response_type {
		deleteOutlookCalendarTokens(input: $input) {
			outlookCalendar {
				id
				calendarUser {
					name
					email
					picture
				}
				calendarTokenError
				enabledCalendars
				calendarFetchEnabled
				calendars {
					edges {
						node {
							id
							name
							description
							backgroundColor
							foregroundColor
						}
					}
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<DeleteOutlookCalendarTokensInput>,
	onSuccess: RelayOnCompleted<DeleteOutlookCalendarTokensMutation>,
	onError: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	const optimisticResponse = {
		deleteOutlookCalendarTokens: {
			outlookCalendar: {
				id: input.id,
				calendarUser: null,
				calendarTokenError: null,
				enabledCalendars: null,
				calendarFetchEnabled: false,
			},
		},
	} as DeleteOutlookCalendarTokensMutation$rawResponse;

	return commitMutation<DeleteOutlookCalendarTokensMutation>(environment, {
		mutation,
		variables,
		optimisticResponse,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
